export { ReactComponent as AdpWorkforceNowLogo } from './adp-workforce-now-logo.svg';
export { ReactComponent as AdpRunLogo } from './adp-run-logo.svg';
export { ReactComponent as CeridianDayforceLogo } from './ceridian-dayforce-logo.svg';
export { ReactComponent as GustoLogo } from './gusto-logo.svg';
export { ReactComponent as JustworksLogo } from './justworks-logo.svg';
export { ReactComponent as PaychexLogo } from './paychex-logo.svg';
export { ReactComponent as PaylocityLogo } from './paylocity.svg';
export { ReactComponent as QuickbooksLogo } from './quickbooks-logo.svg';
export { ReactComponent as RipplingLogo } from './rippling-logo.svg';
export { ReactComponent as TrinetLogo } from './trinet-logo.svg';
export { ReactComponent as ZenefitsLogo } from './zenefits-logo.svg';
export { ReactComponent as NetsuiteLogo } from './netsuite-logo.svg';
export { ReactComponent as CsvLogo } from './csv-logo.svg';
export { ReactComponent as FileLogo } from './file-logo.svg';
export { ReactComponent as ExcelLogo } from './excel-logo.svg';
export { ReactComponent as AsanaLogo } from './asana-logo.svg';
export { ReactComponent as JiraLogo } from './jira-logo.svg';
export { ReactComponent as JiraDataCenterLogo } from './jira-data-center-logo.svg';
export { ReactComponent as LinearLogo } from './linear-logo.svg';
export { ReactComponent as TrelloLogo } from './trello-logo.svg';
export { ReactComponent as GitHubLogo } from './github-logo.svg';
export { ReactComponent as ShortcutLogo } from './shortcut-logo.svg';
export { ReactComponent as WorkdayLogo } from './workday-logo.svg';
